import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DEFAULT_FILTER } from '../../../app/Search/filter';
import {SALE, RENT, APARTMENTS, VIEW_MODE, LANDS, RENTDAILY} from '../../../consts';
import {AutocompleteLocation, MultiSelect, PriceGroup, Select} from '../../Controls';
import { getLocationByFilter, getLocationByDealHandler } from '../../../utils/urls';
import { push } from 'react-router-redux';
import {normalizeLocalityDistricts} from '../../../utils/formater';
import { DEFAULT_EXTEND_FILTER } from '../../../app/Search/filter';
import { addClassById, removeClassById } from '../../../utils/browser';
import TerritorialDivision from '../../TerritorialDivision/TerritorialDivision';
import Territory from '../../../classes/geo/territory';



class HomeSearchBase extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      dealType: props.dealType,
      filter: DEFAULT_FILTER.map((_, key) => props.filter.get(key)),
      prevFilter: props.filter,
      openedExtendFilter: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitMap = this.onSubmitMap.bind(this);
    this.onUpdateState = this.onUpdateState.bind(this);
    this.onReset = this.onReset.bind(this);

    this.getCountSelectedExtendFilter = this.getCountSelectedExtendFilter.bind(this);
    this.toggleExtendFilter = this.toggleExtendFilter.bind(this);
    this.onClickExtendFilter = this.onClickExtendFilter.bind(this);
    this.onPressEnterExtendFilter = this.onPressEnterExtendFilter.bind(this);

    /* обновляет фильтр в internal state */
    this.onUpdateExtendFilterState = this.onUpdateExtendFilterState.bind(this);
    this.onApplyExtendFilterState = this.onApplyExtendFilterState.bind(this);
    this.onResetExtendFilterState = this.onResetExtendFilterState.bind(this);

    this.domain = props.domain;
    this.dealType = props.dealType;
    this.realtyType = props.realtyType;

    this.territory = new Territory(props.domain);
  }

  static getDerivedStateFromProps (props, state) {
    if (!state.prevFilter || !state.prevFilter.equals(props.filter)) {
      return {
        filter: DEFAULT_FILTER.map((_, key) => props.filter.get(key)),
        prevFilter: props.filter
      };
    }

    return null;
  }

  getDictionary () {
    return this.props.dictionary;
  }

  getRealtyType () {
    return null;
  }

  /**
   * Обновляет фильтр в internal state
   * @param filter
   * @param callback
   */
  onUpdateExtendFilterState (filter, callback = null) {
    if (filter.page === undefined && filter.viewMode === undefined) {
      filter.page = 1;
    }

    const originalFilter = this.state.filter;
    const regionId = originalFilter.get('regionId', null) || this.domain.get('regionId');
    const localityId = originalFilter.get('localityId', null) || this.domain.get('localityId', null);
    const token = this.props.user.get('token', null);
    const filterCounter = originalFilter
        .merge(filter)
        .set('regionId', regionId)
        .set('localityId', localityId)
        .set('token', token);
    this.props.loadCountAnnouncement(this.state.dealType, this.getRealtyType(), filterCounter.toJS());

    this.setState({
      filter: originalFilter.merge(filter)
    }, callback || (() => {}));
  }

  /**
   * Обновляет новый фильтр в internal state и применяет изменения
   * @param filter
   */
  onApplyExtendFilterState (filter) {
    this.onUpdateExtendFilterState(filter);
  }

  /**
   * Очищает все выбранные фильтры internal state
   */
  onResetExtendFilterState () {
    let filter = DEFAULT_FILTER.remove('isMls').remove('sort');

    if (this.state.filter.get('viewMode') === VIEW_MODE.map) {
      filter = filter.remove('bounds').remove('areaPolygon');
    }

    filter = filter.remove('viewMode');

    this.onApplyExtendFilterState(filter);
  }

  /**
   * Перекоючает флаг показа/скрытия расширенного фильтра
   * @param flag
   */
  toggleExtendFilter (flag) {
    this.setState({openedExtendFilter: flag});

    if (flag) {
      addClassById('top-wide-screen', 'hide');
      history.replaceState('', document.title, window.location.pathname + window.location.search + '#filter');
    } else {
      removeClassById('top-wide-screen', 'hide');
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    }
  }

  /**
   * Открывает/закрывает расширенный фильтр
   * @param e
   */
  onClickExtendFilter (e) {
    e.preventDefault();

    this.toggleExtendFilter(!this.state.openedExtendFilter);
  }

  /**
   * Нажатие на Enter в расширенном фильтре
   * @param e
   */
  onPressEnterExtendFilter (e) {
    if (e.key === 'Enter') {
      this.onSubmit();
    }
  }

  onReset () {
    this.onResetExtendFilterState();
  }

  onUpdateState (filter, callback = null) {
    this.setState({
      filter: this.state.filter.merge(filter)
    }, callback || (() => {}));
    this.onApplyExtendFilterState(filter);
    this.toggleExtendFilter(false);
  }

  getValue (name) {
    return this.state.filter.get(name, null) || null;
  }

  getNumber (name) {
    const val = this.getValue(name);
    return isNaN(parseInt(val)) ? null : parseInt(val);
  }
    /**
   * Кол-во выбранных параметров в расширенном поиске
   * @returns {*}
   */
  getCountSelectedExtendFilter () {
    return this.state.filter
        .filter((v, k) => DEFAULT_EXTEND_FILTER.has(k))
        .reduce((r, v, k) => r + (v ? 1 : 0), 0);
  }

  /**
   * Возвращает разметку поиска
   * Абстрактный метод, должен быть переопределен
   * @param wrapperClassName
   * @returns {*}
   */
  getQuickSearchBody (wrapperClassName) {
    return <div className={wrapperClassName} />;
  }

  handlerSelect (name) {
    return (_, value) => {
      const filter = {};
      filter[name] = value;
      this.onUpdateState(filter);
    };
  }

  handlerDealType () {
    return (_, value) => {
      const user = this.props.user;
      const location = getLocationByDealHandler(value, this.getRealtyType());
      const filter = {
        objectTypeId: null,
        isMls: null
      };

      if (value === RENT && this.getRealtyType() === APARTMENTS) {
        const isUser = user && (user.getIn(['data', 'id']) || 0);
        const isMls = (isUser && user.getIn(['data', 'hasMls'], false)) || false;

        if (isMls) {
          filter.isMls = 1;
        }
      }

      this.setState({
        dealType: value
      }, () => this.onUpdateState(filter));
      this.props.dispatch(push(location));
    };
  }

  renderDealType (items) {
    return (
      <Select
        items={items}
        name='dealType'
        label=''
        value={this.state.dealType}
        onUpdate={this.handlerDealType()}
      />
    );
  }

  renderObjectType (items, placeholder) {
    return (
      <MultiSelect
        items={items}
        name='objectTypeId'
        value={this.getValue('objectTypeId')}
        placeholder={placeholder}
        onUpdate={this.handlerSelect('objectTypeId')}
      />
    );
  }

  renderDistricts () {
    const districts = normalizeLocalityDistricts(this.domain);

    return (
      !!districts.length && (
        <MultiSelect
          items={districts}
          name='district'
          value={this.getValue('district')}
          placeholder='Район'
          silenceEnabled
          silencePrefix='Район'
          silenceLimit={2}
          onUpdate={this.handlerSelect('district')}
        />
      )
    );
  }

  renderAutocompleteLocation () {
    const { updateAutocompleteOptions } = this.props;
    return (
      <AutocompleteLocation
        isMapView={this.getValue('viewMode', null) === VIEW_MODE.map}
        selectedOptions={[...this.props.selectedOptions]}
        onUpdate={this.onUpdateState}
        updateAutocompleteOptions={updateAutocompleteOptions}
      />
    );
  }

  renderPriceGroup (toggleEnable, labelToggle = 'м2.') {
    return (
      <PriceGroup
        priceMin={this.getNumber('priceMin')}
        priceMax={this.getNumber('priceMax')}
        priceUnitId={this.getNumber('priceUnitId')}
        items={toggleEnable ? [
          {type: 'option', value: 1, label: 'руб.'},
          {type: 'option', value: 2, label: labelToggle}
        ] : null}
        onUpdate={this.onUpdateState}
        fireUpdate
      />
    );
  }

  renderExtendSearch (ExtendSearch) {
    const selectedCount = this.getCountSelectedExtendFilter();

    const {openedExtendFilter: isOpen, filter} = this.state;
    const {
      user,
      dictionary,
      agenciesList,
      offerCount,
    } = this.props;

    const arrowClass = classNames(
      'extend-filter-select-value', 'btn-base', {
        'down': !isOpen,
        'up': isOpen,
        'bandage': selectedCount > 0
      });

    return (
      <div className={'extend-filter-control-box' + (isOpen ? ' open' : '')} onKeyUp={this.onPressEnterExtendFilter}>
        <div className='extend-filter-control-value' onClick={this.onClickExtendFilter}>
          <button className={arrowClass} type='button'>
            Еще фильтры
          </button>
          {selectedCount ? <div className='bandage-count'>{selectedCount}</div> : null}

          { isOpen && <ExtendSearch
            onSubmit={this.onSubmit}
            onReset={this.onReset}
            onUpdate={this.onApplyExtendFilterState}
            dictionary={dictionary}
            filter={filter}
            user={user}
            agenciesList={agenciesList}
            offerCount={offerCount}
            onSubmitMap={this.onSubmitMap}
            />
          }

        </div>
      </div>
    );
  }

  renderTerritorialDivision () {
    const { domain, offerCount } = this.props;
    const { filter } = this.state;

    return (
      !this.territory.isEmpty() &&
        <TerritorialDivision
          domain={domain}
          filter={filter}
          offerCount={offerCount}
          onApply={this.onApplyExtendFilterState}
          onUpdate={this.onUpdateExtendFilterState} />
    );
  }

  renderSubmit () {
    const { offerCount } = this.props;
    return (
      <button onClick={this.onSubmit} className='btn-base btn-primary submit'>{offerCount ? `Показать ${offerCount} объявлений` : 'Найти'}</button>
    );
  }

  renderMapSubmit () {
    return (
      <button onClick={this.onSubmitMap} className='btn-base btn-hollow primary submit'>
        <span className="icon icon-map-marker-new"></span>
        На карте
      </button>
    );
  }

  onSubmit () {
    const realtyType = this.getRealtyType();
    const { dealType, filter } = this.state;

    const location = getLocationByFilter(filter, dealType, realtyType);

    this.props.dispatch(push(location));
    this.toggleExtendFilter(false);
  }

  onSubmitMap () {
    this.onUpdateState({
      viewMode: VIEW_MODE.map
    }, this.onSubmit);
  }

  render () {
    return (
      <div className='home-quick-search-wrp'>
        { this.getQuickSearchBody('home-quick-search')}
        <div className='home-quick-search-map-section'>
          { this.renderMapSubmit() }
          { this.renderSubmit() }
        </div>
      </div>
    );
  }
}

HomeSearchBase.propTypes = {
  domain: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  offerCount: PropTypes.number.isRequired,
  setSection: PropTypes.func.isRequired,
  updateAutocompleteOptions: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array.isRequired,
};

HomeSearchBase.defaultProps = {};

export default HomeSearchBase;



// WEBPACK FOOTER //
// ./src/ui/Search/HomeSearch/HomeSearchBase.jsx